import {MI} from "../init";
import {MadnesObject} from "../libs/mi/MadnesObject";

/**
 * @param {GameConfig} gameConfig
 * @constructor
 */
import {madnes_angle_between, madnes_distance, madnes_rad_to_deg} from "../../framework/src/engine/madnes/madnes";

export default function GameWinlines(gameConfig, gameGroups) {

    /** @type {GameConfig} */
    this._gameConfig = gameConfig;

    /** @type {GameGroups} */
    this._groups = gameGroups;

    this._winlines_pos_x = [];

    this._winlines_pos_y = [];

    /** @type {Object<string,MadnesObject>} */
    this._lines = {};

    /** @type {MadnesGraphics} */
    this._mask;

    this._winlineLength = 287;
}

GameWinlines.prototype._draw_winlines = function() {

    this._winlines_pos_y = [160, 350, 550, 0];

    for(var i = 0; i < this._gameConfig.reelsPositions.length; i++)
    {
        this._winlines_pos_x[i] = this._gameConfig.reelsPositions[i]['x'];
    }

    this._winlines_pos_y = [160, 350, 550, 0];

    this._createLines();

    var groupWinlines = this._groups.get("group_winlines");

    for(var i = 0; i <= 80; i++) {
        groupWinlines.add(this._groups.get("group_winline_" + i));
    }

    this._mask = MI.addGraphics(0, 0, "graphics_winline_mask");
    this._mask.beginFill(0x000000);
    this._mask.drawRectangle(0, 0, MI.getWi(), MI.getHe());
    this._mask.setScale(1, 1);

    groupWinlines.setMask(this._mask);
};

GameWinlines.prototype._createLines = function() {

    this._draw_winline_2(0, 0, [0, 0], [1, 0]);
    this._draw_winline_2(0, 1, [1, 0], [2, 0]);
    this._draw_winline_2(0, 2, [2, 0], [3, 0]);

    this._draw_winline_2(1, 0, [0, 0], [1, 0]);
    this._draw_winline_2(1, 1, [1, 0], [2, 0]);
    this._draw_winline_2(1, 2, [2, 0], [3, 1]);

    this._draw_winline_2(2, 0, [0, 0], [1, 0]);
    this._draw_winline_2(2, 1, [1, 0], [2, 0]);
    this._draw_winline_2(2, 2, [2, 0], [3, 2]);

    this._draw_winline_2(3, 0, [0, 0], [1, 0]);
    this._draw_winline_2(3, 1, [1, 0], [2, 1]);
    this._draw_winline_2(3, 2, [2, 1], [3, 0]);

    this._draw_winline_2(4, 0, [0, 0], [1, 0]);
    this._draw_winline_2(4, 1, [1, 0], [2, 1]);
    this._draw_winline_2(4, 2, [2, 1], [3, 1]);

    this._draw_winline_2(5, 0, [0, 0], [1, 0]);
    this._draw_winline_2(5, 1, [1, 0], [2, 1]);
    this._draw_winline_2(5, 2, [2, 1], [3, 2]);

    this._draw_winline_2(6, 0, [0, 0], [1, 0]);
    this._draw_winline_2(6, 1, [1, 0], [2, 2]);
    this._draw_winline_2(6, 2, [2, 2], [3, 0]);

    this._draw_winline_2(7, 0, [0, 0], [1, 0]);
    this._draw_winline_2(7, 1, [1, 0], [2, 2]);
    this._draw_winline_2(7, 2, [2, 2], [3, 1]);

    this._draw_winline_2(8, 0, [0, 0], [1, 0]);
    this._draw_winline_2(8, 1, [1, 0], [2, 2]);
    this._draw_winline_2(8, 2, [2, 2], [3, 2]);

    this._draw_winline_2(9, 0, [0, 0], [1, 1]);
    this._draw_winline_2(9, 1, [1, 1], [2, 0]);
    this._draw_winline_2(9, 2, [2, 0], [3, 0]);

    this._draw_winline_2(10, 0, [0, 0], [1, 1]);
    this._draw_winline_2(10, 1, [1, 1], [2, 0]);
    this._draw_winline_2(10, 2, [2, 0], [3, 1]);

    this._draw_winline_2(11, 0, [0, 0], [1, 1]);
    this._draw_winline_2(11, 1, [1, 1], [2, 0]);
    this._draw_winline_2(11, 2, [2, 0], [3, 2]);

    this._draw_winline_2(12, 0, [0, 0], [1, 1]);
    this._draw_winline_2(12, 1, [1, 1], [2, 1]);
    this._draw_winline_2(12, 2, [2, 1], [3, 0]);

    this._draw_winline_2(13, 0, [0, 0], [1, 1]);
    this._draw_winline_2(13, 1, [1, 1], [2, 1]);
    this._draw_winline_2(13, 2, [2, 1], [3, 1]);

    this._draw_winline_2(14, 0, [0, 0], [1, 1]);
    this._draw_winline_2(14, 1, [1, 1], [2, 1]);
    this._draw_winline_2(14, 2, [2, 1], [3, 2]);

    this._draw_winline_2(15, 0, [0, 0], [1, 1]);
    this._draw_winline_2(15, 1, [1, 1], [2, 2]);
    this._draw_winline_2(15, 2, [2, 2], [3, 0]);

    this._draw_winline_2(16, 0, [0, 0], [1, 1]);
    this._draw_winline_2(16, 1, [1, 1], [2, 2]);
    this._draw_winline_2(16, 2, [2, 2], [3, 1]);

    this._draw_winline_2(17, 0, [0, 0], [1, 1]);
    this._draw_winline_2(17, 1, [1, 1], [2, 2]);
    this._draw_winline_2(17, 2, [2, 2], [3, 2]);

    this._draw_winline_2(18, 0, [0, 0], [1, 2]);
    this._draw_winline_2(18, 1, [1, 2], [2, 0]);
    this._draw_winline_2(18, 2, [2, 0], [3, 0]);

    this._draw_winline_2(19, 0, [0, 0], [1, 2]);
    this._draw_winline_2(19, 1, [1, 2], [2, 0]);
    this._draw_winline_2(19, 2, [2, 0], [3, 1]);

    this._draw_winline_2(20, 0, [0, 0], [1, 2]);
    this._draw_winline_2(20, 1, [1, 2], [2, 0]);
    this._draw_winline_2(20, 2, [2, 0], [3, 2]);

    this._draw_winline_2(21, 0, [0, 0], [1, 2]);
    this._draw_winline_2(21, 1, [1, 2], [2, 1]);
    this._draw_winline_2(21, 2, [2, 1], [3, 0]);

    this._draw_winline_2(22, 0, [0, 0], [1, 2]);
    this._draw_winline_2(22, 1, [1, 2], [2, 1]);
    this._draw_winline_2(22, 2, [2, 1], [3, 1]);

    this._draw_winline_2(23, 0, [0, 0], [1, 2]);
    this._draw_winline_2(23, 1, [1, 2], [2, 1]);
    this._draw_winline_2(23, 2, [2, 1], [3, 2]);

    this._draw_winline_2(24, 0, [0, 0], [1, 2]);
    this._draw_winline_2(24, 1, [1, 2], [2, 2]);
    this._draw_winline_2(24, 2, [2, 2], [3, 0]);

    this._draw_winline_2(25, 0, [0, 0], [1, 2]);
    this._draw_winline_2(25, 1, [1, 2], [2, 2]);
    this._draw_winline_2(25, 2, [2, 2], [3, 1]);

    this._draw_winline_2(26, 0, [0, 0], [1, 2]);
    this._draw_winline_2(26, 1, [1, 2], [2, 2]);
    this._draw_winline_2(26, 2, [2, 2], [3, 2]);

    this._draw_winline_2(27, 0, [0, 1], [1, 0]);
    this._draw_winline_2(27, 1, [1, 0], [2, 0]);
    this._draw_winline_2(27, 2, [2, 0], [3, 0]);

    this._draw_winline_2(28, 0, [0, 1], [1, 0]);
    this._draw_winline_2(28, 1, [1, 0], [2, 0]);
    this._draw_winline_2(28, 2, [2, 0], [3, 1]);

    this._draw_winline_2(29, 0, [0, 1], [1, 0]);
    this._draw_winline_2(29, 1, [1, 0], [2, 0]);
    this._draw_winline_2(29, 2, [2, 0], [3, 2]);

    this._draw_winline_2(30, 0, [0, 1], [1, 0]);
    this._draw_winline_2(30, 1, [1, 0], [2, 1]);
    this._draw_winline_2(30, 2, [2, 1], [3, 0]);

    this._draw_winline_2(31, 0, [0, 1], [1, 0]);
    this._draw_winline_2(31, 1, [1, 0], [2, 1]);
    this._draw_winline_2(31, 2, [2, 1], [3, 1]);

    this._draw_winline_2(32, 0, [0, 1], [1, 0]);
    this._draw_winline_2(32, 1, [1, 0], [2, 1]);
    this._draw_winline_2(32, 2, [2, 1], [3, 2]);

    this._draw_winline_2(33, 0, [0, 1], [1, 0]);
    this._draw_winline_2(33, 1, [1, 0], [2, 2]);
    this._draw_winline_2(33, 2, [2, 2], [3, 0]);

    this._draw_winline_2(34, 0, [0, 1], [1, 0]);
    this._draw_winline_2(34, 1, [1, 0], [2, 2]);
    this._draw_winline_2(34, 2, [2, 2], [3, 1]);

    this._draw_winline_2(35, 0, [0, 1], [1, 0]);
    this._draw_winline_2(35, 1, [1, 0], [2, 2]);
    this._draw_winline_2(35, 2, [2, 2], [3, 2]);

    this._draw_winline_2(36, 0, [0, 1], [1, 1]);
    this._draw_winline_2(36, 1, [1, 1], [2, 0]);
    this._draw_winline_2(36, 2, [2, 0], [3, 0]);

    this._draw_winline_2(37, 0, [0, 1], [1, 1]);
    this._draw_winline_2(37, 1, [1, 1], [2, 0]);
    this._draw_winline_2(37, 2, [2, 0], [3, 1]);

    this._draw_winline_2(38, 0, [0, 1], [1, 1]);
    this._draw_winline_2(38, 1, [1, 1], [2, 0]);
    this._draw_winline_2(38, 2, [2, 0], [3, 2]);

    this._draw_winline_2(39, 0, [0, 1], [1, 1]);
    this._draw_winline_2(39, 1, [1, 1], [2, 1]);
    this._draw_winline_2(39, 2, [2, 1], [3, 0]);

    this._draw_winline_2(40, 0, [0, 1], [1, 1]);
    this._draw_winline_2(40, 1, [1, 1], [2, 1]);
    this._draw_winline_2(40, 2, [2, 1], [3, 1]);

    this._draw_winline_2(41, 0, [0, 1], [1, 1]);
    this._draw_winline_2(41, 1, [1, 1], [2, 1]);
    this._draw_winline_2(41, 2, [2, 1], [3, 2]);

    var k = 41;
    k++;
    this._draw_winline_2(k, 0, [0, 1], [1, 1]);
    this._draw_winline_2(k, 1, [1, 1], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 1], [1, 1]);
    this._draw_winline_2(k, 1, [1, 1], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 1], [1, 1]);
    this._draw_winline_2(k, 1, [1, 1], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 2]);

    k = 44;
    k++;
    this._draw_winline_2(k, 0, [0, 1], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 0]);
    this._draw_winline_2(k, 2, [2, 0], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 1], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 0]);
    this._draw_winline_2(k, 2, [2, 0], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 1], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 0]);
    this._draw_winline_2(k, 2, [2, 0], [3, 2]);

    k = 47;
    k++;
    this._draw_winline_2(k, 0, [0, 1], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 1]);
    this._draw_winline_2(k, 2, [2, 1], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 1], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 1]);
    this._draw_winline_2(k, 2, [2, 1], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 1], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 1]);
    this._draw_winline_2(k, 2, [2, 1], [3, 2]);

    k = 50;
    k++;
    this._draw_winline_2(k, 0, [0, 1], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 1], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 1], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 2]);

    k = 53;
    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 0]);
    this._draw_winline_2(k, 1, [1, 0], [2, 0]);
    this._draw_winline_2(k, 2, [2, 0], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 0]);
    this._draw_winline_2(k, 1, [1, 0], [2, 0]);
    this._draw_winline_2(k, 2, [2, 0], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 0]);
    this._draw_winline_2(k, 1, [1, 0], [2, 0]);
    this._draw_winline_2(k, 2, [2, 0], [3, 2]);

    k = 56;
    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 0]);
    this._draw_winline_2(k, 1, [1, 0], [2, 1]);
    this._draw_winline_2(k, 2, [2, 1], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 0]);
    this._draw_winline_2(k, 1, [1, 0], [2, 1]);
    this._draw_winline_2(k, 2, [2, 1], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 0]);
    this._draw_winline_2(k, 1, [1, 0], [2, 1]);
    this._draw_winline_2(k, 2, [2, 1], [3, 2]);

    k = 59;
    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 0]);
    this._draw_winline_2(k, 1, [1, 0], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 0]);
    this._draw_winline_2(k, 1, [1, 0], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 0]);
    this._draw_winline_2(k, 1, [1, 0], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 2]);

    k = 62;
    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 1]);
    this._draw_winline_2(k, 1, [1, 1], [2, 0]);
    this._draw_winline_2(k, 2, [2, 0], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 1]);
    this._draw_winline_2(k, 1, [1, 1], [2, 0]);
    this._draw_winline_2(k, 2, [2, 0], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 1]);
    this._draw_winline_2(k, 1, [1, 1], [2, 0]);
    this._draw_winline_2(k, 2, [2, 0], [3, 2]);

    k = 65;
    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 1]);
    this._draw_winline_2(k, 1, [1, 1], [2, 1]);
    this._draw_winline_2(k, 2, [2, 1], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 1]);
    this._draw_winline_2(k, 1, [1, 1], [2, 1]);
    this._draw_winline_2(k, 2, [2, 1], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 1]);
    this._draw_winline_2(k, 1, [1, 1], [2, 1]);
    this._draw_winline_2(k, 2, [2, 1], [3, 2]);

    k = 68;
    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 1]);
    this._draw_winline_2(k, 1, [1, 1], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 1]);
    this._draw_winline_2(k, 1, [1, 1], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 1]);
    this._draw_winline_2(k, 1, [1, 1], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 2]);

    k = 71;
    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 0]);
    this._draw_winline_2(k, 2, [2, 0], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 0]);
    this._draw_winline_2(k, 2, [2, 0], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 0]);
    this._draw_winline_2(k, 2, [2, 0], [3, 2]);

    k = 74;
    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 1]);
    this._draw_winline_2(k, 2, [2, 1], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 1]);
    this._draw_winline_2(k, 2, [2, 1], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 1]);
    this._draw_winline_2(k, 2, [2, 1], [3, 2]);

    k = 77;
    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 0]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 1]);

    k++;
    this._draw_winline_2(k, 0, [0, 2], [1, 2]);
    this._draw_winline_2(k, 1, [1, 2], [2, 2]);
    this._draw_winline_2(k, 2, [2, 2], [3, 2]);
};

GameWinlines.prototype._draw_winline_2 = function(line, part, pos1, pos2) {

    var posX1 = this._winlines_pos_x[pos1[0]];
    var posY1 = this._winlines_pos_y[pos1[1]];
    var posX2 = this._winlines_pos_x[pos2[0]];
    var posY2 = this._winlines_pos_y[pos2[1]];

    var dist = madnes_distance(posX1, posY1, posX2, posY2);

    var len = dist / this._winlineLength;

    this._draw_line(line, part, posX1, posY1, len, madnes_rad_to_deg(madnes_angle_between(posX1, posY1, posX2, posY2)));

};

GameWinlines.prototype._draw_line = function(line, part, xPos, yPos, length, angle) {

    var group = this._groups.get("group_winline_" + line);
    if(!group) {
        group = this._groups.create("group_winline_" + line);
    }

    var lineImg = MI.addImg(xPos, yPos, "winline_0", "winline_" + line + "_line_" + part);
    lineImg.setAnchor(0, 0.5);
    lineImg.setScale(length, 1);
    angle && lineImg.setAngle(angle);

    group.add(lineImg);

    this._lines["winline_" + line + "_line_" + part] = lineImg;
};

GameWinlines.prototype._set_linewin_length = function(line, len) {

    for(var i = 0; i < this._gameConfig.reelsPositions.length; ++i) {

        if(MadnesObject.keyExists("winline_" + line + "_line_" + i)) {
            this._lines["winline_" + line + "_line_" + i].setVisible(i < len);
        }
    }
};

GameWinlines.prototype.create = function() {
    this._draw_winlines();
    this.hideWinlines();
};

GameWinlines.prototype.hideWinlines = function() {
    for(var i = 0; i < 81; i++) {
        this._groups.get("group_winline_" + i).setVisible(false);
    }
};

/**
 * @param {Array<ServerResultWinline>} lineWins
 * @returns {Promise}
 */
GameWinlines.prototype.animWinlines = function(lineWins) {

    var _self = this;

    return new Promise(function(res) {

        _self.hideWinlines();

        for(var i = 0; i < lineWins.length; i++) {

            /** @type {ServerResultWinline} */
            var lineWin = lineWins[i];

            _self._groups.get("group_winline_" + lineWin.getLine()).setVisible(true);
            _self._set_linewin_length(lineWin.getLine(), lineWin.getPosition().length - 1);
        }

        _self._mask.setScale(0, 1);

        MI.addTween().to(_self._mask, { 'x': 1 }, {
            'scale': true,
            'duration': 600,
            'callback': res
        });
    });
};